import React from "react";

export default function ApproveButton({
  disabled = false,
  onApprove,
  approveClassName = "fp-ai-btn fp-ai-btn--approve FP_Body",
}) {
  return (
    <>
      <button
        type="button"
        className={approveClassName}
        disabled={disabled}
        onClick={onApprove}
      >
        Approve
      </button>
    </>
  );
}
